<div class="mat-typography mat-body mat-app-background">
  <h2 class="drug-cost-header"><slot name="header">View Estimated Total Costs Per:</slot></h2>

  <mat-radio-group
    aria-labelledby="toggle-radio-group"
    class="toggle-radio-group"
    (change)="updateSelection($event)"
    [(ngModel)]="retailMailOrderSwitch"
    [disabled]="!hasMailCosts"
    >
    @for (option of options; track option) {
      <mat-radio-button
        color="primary"
        class="toggle-radio-button"
        [value]="option.value"
        >
        {{ option.label }}
      </mat-radio-button>
    }
  </mat-radio-group>
</div>
